import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { TemplateInvocationVariableFields } from "./template-invocation-variable-fields";
import {
  OrdinaryVariableDialog,
  type TemplateVariableDialogProps,
} from "./template-ordinary-variable-dialog";
export function TemplateVariableDialog(props: TemplateVariableDialogProps) {
  if (!props.open) return null;
  const invocationRow =
    props.variable &&
    ["subanalysis_call", "subanalysis_source", "bound_input"].includes(
      props.variable.variable_role,
    );
  if (invocationRow && props.variable && props.target.level === "analysisstep")
    return (
      <Dialog open={props.open} onOpenChange={props.onOpenChange}>
        <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>Edit variable</DialogTitle>
            <DialogDescription>
              Changes are sent only after you press Save.
            </DialogDescription>
          </DialogHeader>
          {props.open && (
            <TemplateInvocationVariableFields
              variable={props.variable}
              variables={props.variables}
              templateId={props.target.templateId}
              stepId={props.target.stepId}
              tenantId={props.editorData.currentTenantId}
              onClose={() => props.onOpenChange(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    );
  return <OrdinaryVariableDialog {...props} />;
}
